/** In-memory cache of the household's tables plus UI state. The UI reads from here and writes only through api.* */
import { TABLES } from '../shared/constants';
import type { Row, TableName, Tables } from '../shared/types';
import { J } from '../shared/util';
import { DEFAULTS } from '../shared/constants';

export interface UIState {
  capture: { pending: PendingPhoto[]; sel: number; qty: number; room?: string; name?: string; category?: string; roomSheet?: boolean; preview?: boolean; flash?: boolean };
  cart: { id: string; price: number }[];
  labelSel: string[]; labelMode: 'boxes' | 'batch'; labelTpl: string | null; labelCopies: number; labelStart: number;
  batchPrefix?: string; batchStart?: number; batchCount?: number;
  invFilter: string; invq: string; invRoom: string; boxFilter?: string; saleCat?: string; dest?: string | null;
  buyCheck?: any; ruleCountry?: string; signin?: any; signedOut?: boolean;
  pub: Record<string, any>; // public sale payloads by slug
  flash?: string | null;
}
export interface PendingPhoto { big: { blob: Blob; w: number; h: number }; small: { blob: Blob; w: number; h: number }; url: string; role: string }

export const S: { tables: Tables; me: Row | null; household: Row | null; config: Record<string, any>; mode: 'remote' | 'local'; ui: UIState } = {
  tables: {}, me: null, household: null, config: {}, mode: 'remote',
  ui: { capture: { pending: [], sel: 0, qty: 1 }, cart: [], labelSel: [], labelMode: 'boxes', labelTpl: null, labelCopies: 2, labelStart: 1, invFilter: 'all', invq: '', invRoom: '', pub: {} },
};

export const T = (name: TableName | string): Row[] => ((S.tables as any)[name] ||= []);
export const byId = (name: TableName | string, id?: string | null): Row | undefined => id ? T(name).find(r => r.id === id) : undefined;
export function setTables(t: Tables) { S.tables = t; for (const n of TABLES) T(n); }

export const Settings = {
  get(k: string): any { const r = T('settings').find(s => s.key === k); return r ? J(r.value, DEFAULTS[k]) : (k === 'public_base_url' ? (S.config.public_base_url || DEFAULTS[k]) : DEFAULTS[k]); },
};
